import React from "react";
import Header from "../components/Header";
import Achievements from "../Home/components/Achievements";
import FirstQA from "./components/FirstQA";
import QAHeroImg from "../assets/images/qa/qa-hero-bg.png";

const QA = () => {
  return (
    <>
      <Header
        src={QAHeroImg}
        alt="A"
        title="Ensuring Excellence:"
        title2="Our Commitment to Quality Assurance in Every Stitch"
      />
      <FirstQA />
      <Achievements />
    </>
  );
};

export default QA;
